import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import VerticalLine from '../assets/images/vertical_line.png';
import BkLogoImg from '../assets/images/Burger_King.png';
import './frontBeforeStarted.scss';

function BackBeforeStarted() {
  return (
    <div id="container">
      <div className="grid container_box">
        <div className="title">
          <h2>FAQs before getting started with UPshow</h2>
        </div>
        <div className="col-12 accordion-demo">
          <div className="acordion">
            <Accordion>
              <AccordionTab header="How do I know if UPshow works with my POS system?">
                <p className="faq-item">
                  UPshow&apos;s POS partner list is expansive and growing by the day. Request a quote from us to find out if your
                  POS system is a current partner or can be added.
                </p>
              </AccordionTab>
              <AccordionTab header="What do I do once I receive my device?">
                <p className="faq-item">
                  Plug in your device, connect to the internet and that&apos;s it! If you have any questions, not to worry:
                  UPshow&apos;s support team is available to help you. Once you&apos;re plugged in, you&apos;ll be able to
                  customize your screens via the UPshow Manager.
                </p>
              </AccordionTab>
              <AccordionTab header="Does UPshow require an internet connection?">
                <p className="faq-item">
                  Yes. When your UPshow device is plugged into a TV or AV system for the first time, you will be prompted to
                  connect a Wi-Fi network. If you choose to connect your UPshow device via ethernet, you will not need to connect
                  the device to a Wi-Fi network.
                </p>
              </AccordionTab>
              <AccordionTab header="How do I manage UPshow?">
                <p className="faq-item">
                  Using the UPshow Manager, you can control the content on your screens from your laptop, phone and tablet no
                  matter where you are!
                </p>
              </AccordionTab>
              <AccordionTab header="Are there usage limits?">
                <p className="faq-item">
                  No, there are no usage limits. Your UPshow device runs on your business&apos;s internet connection. As long as
                  your device is connected, you will be able to use UPshow.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      </div>
      <section className="section_light_grey quote_section">
        <div className="vertical_line absolute">
          <img className="img_line" src={VerticalLine} alt="line" />
        </div>
        <div className="flex flex-column align-items-center margin_0_auto max-w-max testimonial_box">
          <div className="img_box">
            <img className="logo_img" src={BkLogoImg} alt="Burger King Logo" />
          </div>
          <div className="opinion">
            <p>
              “UPshow makes our restaurants more efficient and better places to work, which will lead to higher productivity and
              employee retention.”
            </p>
          </div>
          <div className="flex flex-column align-self-start author_box">
            <h3 className="author_text">Benjamin Wasser.</h3>
            <h3 className="author_text">COO</h3>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BackBeforeStarted;
